import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { BaseAvatar } from '../base-avatar/base-avatar';
import { QueueIconMap } from './queue-icons';
import { Icon } from '../../primitives/icon/icon';
export var getQueueInitials = function (name) {
    var maxLetters = 1;
    var initials = name.split(' ')
        .reduce(function (result, currentWord, idx) {
        return idx >= maxLetters ? result : "" + result + currentWord.substring(0, 1).toUpperCase();
    }, '');
    return initials.length ? initials : 'NA';
};
export var QueueAvatar = function (props) {
    var queue = props.queue;
    var text = getQueueInitials(queue.name);
    var size = props.size || 'normal';
    var className = namespacedClassnames('queue-avatar', size, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(BaseAvatar, { size: size, id: queue.id, initials: text }),
        React.createElement(Icon, { icon: QueueIconMap[size] })));
};
//# sourceMappingURL=queue-avatar.js.map